import { OnRaceBetsSchema } from './OnRaceBets.styles';

export const onRaceBetStyles: OnRaceBetsSchema = {
  wrapper: {
    mb: '2',
    bg: 'white',
    borderRadius: 'md',
    flexDirection: 'column',
    boxShadow:
      '0px 0px 0px 2px var(--bc-colors-beta-500) inset,0px 0px 0px 4px var(--bc-colors-alpha-800) inset,0px 0px 0px 5px rgba(255, 255, 255, 0.30) inset',
    p: '2',
  },
  headerWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: 'alpha.700',
  },
  headerCountText: {
    ml: '1',
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'alpha.700',
  },
  headerExpandButton: {
    variant: 'primary',
    ml: 'auto',
    mr: '1',
    boxSize: '7',
    sx: {
      w: '10',
    },
  },
  toggleIcon: {
    boxSize: '4',
  },
  betsContainer: {
    flexDirection: 'column',
  },
  betCategoryWrapper: {
    alignItems: 'center',
    mt: '2',
  },
  betCategory: {
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'alpha.700',
  },
  betCategoryCount: {
    fontSize: 'xs',
    fontWeight: 'semibold',
    color: 'alpha.700',
    ml: '1',
  },
  divider: {
    borderWidth: 'px',
    opacity: '1',
    borderColor: 'blackAlpha.400',
    mt: '1.5',
  },
  betRow: {
    py: '2',
  },
  betRowDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'blackAlpha.200',
    borderBottomStyle: 'dashed',
  },
  groupDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'blackAlpha.400',
  },
  categoryIcon: {
    color: 'gray.600',
    boxSize: '6',
  },
  groupContainer: {
    flexDir: 'column',
    py: 2,
    borderBottomWidth: '1px',
    borderBottomColor: 'blackAlpha.400',
  },
  groupTitleText: {
    color: 'brand.700',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
  runnerText: {
    color: 'gray.600',
    fontSize: 'sm',
    fontWeight: 'extrabold',
    textTransform: 'capitalize',
  },
  runnerBarrierText: {
    color: 'black',
    fontSize: 'xs',
  },
  stakeText: {
    color: 'black',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  potentialWinningsText: {
    color: 'black',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  subtitleText: {
    color: 'gray.600',
    fontSize: 'xs',
    fontWeight: 'medium',
  },
  exoticsPositionText: {
    color: 'gray.600',
    fontSize: 'xs',
    fontWeight: 'bold',
    w: 9,
  },
  viewMoreButton: {
    bg: 'brand.600',
    alignItems: 'center',
    justifyContent: 'center',
    mx: -2,
    mb: -2,
    borderTopRadius: 0,
    height: 8,
  },
  viewMoreButtonText: {
    fontWeight: 'black',
    fontSize: 'sm',
    textTransform: 'uppercase',
  },
  srmBlendedLegContainer: {
    flexDir: 'row',
    flex: '1',
  },
  srmBlendedRunnerText: {
    width: 32,
    fontWeight: 'bold',
    color: 'gray.600',
    fontSize: 'xs',
    textTransform: 'capitalize',
  },
  srmMarketText: {
    fontWeight: 'bold',
    color: 'gray.600',
    fontSize: 'xs',
  },
  srmBlendedWrapper: {
    flexDir: 'column',
    flex: 1,
  },
  flexiText: {
    fontWeight: 'bold',
    color: 'gray.600',
    fontSize: 'xs',
  },
  flexiStakeText: {
    width: '16',
    color: 'gray.600',
  },
  flexiStakeValueText: {
    color: 'alpha.400',
    fontWeight: 'bold',
  },
};
